<section class="page-container">
  <div class="container-fluid" style="padding: 0">
    <div class="c-class-header">
      <h1>Mercedes-Benz
        <br>
        <span>C-Class</span>
      </h1>
      <img src="../../assets/images/showroom-banners/c-class.png">
    </div>
  </div>
</section>
<app-showroom></app-showroom>
